import { NotificationGroupName } from 'src/models/notifications/types';
import { NotificationType, NotificationSettingMode } from '@tendium/prom-types/notifications';

export interface INotificationSettingsGroup {
  name: NotificationGroupName;
  isActive: boolean;
  notificationSettings: INotificationSetting[];
}

export interface INotificationSetting {
  name: NotificationType;
  isActive: boolean;
  notificationSettingValues: INotificationSettingsValue[];
  itemId?: string;
}

export interface INotificationSettingsValue {
  mode: NotificationSettingMode;
  value: boolean;
}

export function isNotificationSettingsMode(u: unknown): u is NotificationSettingMode {
  return typeof u === 'string' && Object.values(NotificationSettingMode).some(v => v === u);
}
